// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"Backdrop__Backdrop___35g8h","Sidebar":"Backdrop__Sidebar___1k8ir"};